import React from "react";

const MenuColazione = () => {
	return (
		<section className="module">
			<div className="container">
				<div className="row">
					<div className="col-sm-2 col-sm-offset-5">
						<div className="alt-module-subtitle">
							<span className="holder-w"></span>
							<span className="holder-w"></span>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-8 col-sm-offset-2">
						<h2 className="module-title font-alt">Colazione della Fioreria</h2>
					</div>
				</div>
				<div className="row multi-columns-row">
					<div className="col-sm-6">
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">
										<b>ESPRESSO IN PIEDI</b>
									</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€1,0</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Espresso</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€1,3</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Decaffeinato</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€1,4</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Macchiato</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€1,4</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">MacchiatoVegan</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€1,4</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Cappuccio</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€1,8</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">CappuccioVegan</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€2</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Orzo / Ginseng</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€1,7</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Marocchino</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€1,9</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Corretto</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€2,0</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Latte Macchiato</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€2,2</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Latte Macchiato Vegan</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€2,5</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Caffè Americano</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€2,0</h4>
								</div>
							</div>
						</div>
					</div>
					<div className="col-sm-6">
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">
										<b>E I DOLCI.</b>
									</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt"></h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">
										Brioches da pasticceria, tra cui scelta vegan e no glutine (su disponibilità)
									</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">da €1,8 a €2,5</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Pain au chocolat</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€2,0</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
				<br />
				<div className="row multi-columns-row">
					<div className="col-sm-6">
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">
										<b>E LE BEVANDE.</b>
									</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt"></h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Bibite e concentrati di frutta</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€3,0</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Infuso</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€3</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Spremuta</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€4</h4>
								</div>
							</div>
						</div>
						<div className="menu">
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">Acqua 1L</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">€2</h4>
								</div>
							</div>
						</div>
					</div>
					<div className="col-sm-6">
						<div className="menu">
							<div className="menu">
								<div className="row">
									<div className="col-sm-8">
										<h4 className="menu-title font-alt">
											<b>E I SALATI.</b>
										</h4>
										<div className="menu-detail font-serif"></div>
									</div>
									<div className="col-sm-4 menu-price-detail">
										<h4 className="menu-price font-alt"></h4>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-sm-8">
									<h4 className="menu-title font-alt">
										Panini al vapore vegetali, focacce della casa al Parsut, panini morbidi base di
										salumi e salse. Tutto estemporaneo, tutto da vedere. Anche da proporre in base a
										cosa bolle in pentola e in dispensa.
									</h4>
									<div className="menu-detail font-serif"></div>
								</div>
								<div className="col-sm-4 menu-price-detail">
									<h4 className="menu-price font-alt">da €4 a €6</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default MenuColazione;
